import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'articleTitleCase',
})
export class ArticleTitleCasePipe implements PipeTransform {
  transform(text: string | null): string | null {
    if (!text) {
      return text;
    }
    return text[0].toUpperCase() + text.substr(1).toLowerCase();
  }
}
